import { externalRoutes, routes } from '~constants/routes';
import annalsNavigation from '~features/annals/hooks/navigation';

export const useNavigationLinksAnalytics = (sideMenu: boolean) => {
	const annalsNavAboutClicked = annalsNavigation.useNavAboutClicked();

	const annalsNavTopGridClicked = annalsNavigation.useNavTopGridButtonClicked();
	const annalsNavSideGridClicked =
		annalsNavigation.useNavLeftGridButtonClicked();

	const annalsNavTopGalleryClicked = annalsNavigation.useNavTopGalleryClicked();
	const annalsNavSideGalleryClicked =
		annalsNavigation.useNavLeftGalleryClicked();

	const annalsNavTopChatsClicked =
		annalsNavigation.useNavTopChatsButtonClicked();
	const annalsNavSideChatsClicked =
		annalsNavigation.useNavLeftChatsButtonClicked();

	const annalsNavTopCreateCharacterClicked =
		annalsNavigation.useNavTopCreateCharacterButtonClicked();
	const annalsNavSideCreateCharacterClicked =
		annalsNavigation.useNavLeftCreateCharacterButtonClicked();

	// const annalsNavTopCreateImageClicked =
	// 	annalsNavigation.useNavTopCreateImageButtonClicked();
	const annalsNavSideCreateImageClicked =
		annalsNavigation.useNavLeftCreateImageButtonClicked();

	const annalsNavTopCreateVideoClicked =
		annalsNavigation.useNavTopCreateVideoButtonClicked();
	const annalsNavSideCreateVideoClicked =
		annalsNavigation.useNavLeftCreateVideoButtonClicked();

	const annalsNavSideAffiliateClicked =
		annalsNavigation.useNavLeftAffiliateButtonClicked();
	const annalsNavSidePartnershipClicked =
		annalsNavigation.useNavLeftPartnershipButtonClicked();

	const annalsNavigationClick = (path: string) => {
		switch (path) {
			case routes.explore.models:
			case routes.explore.home:
				return sideMenu ? annalsNavSideGridClicked : annalsNavTopGridClicked;
			case routes.gallery.home:
				return sideMenu
					? annalsNavSideGalleryClicked
					: annalsNavTopGalleryClicked;
			case routes.chats.home:
				return sideMenu ? annalsNavSideChatsClicked : annalsNavTopChatsClicked;
			case routes.company.about:
				return annalsNavAboutClicked;
			case routes.generate.images.community:
				return sideMenu
					? annalsNavSideCreateImageClicked
					: annalsNavTopGalleryClicked;
			case routes.generate.videos.community:
				return sideMenu
					? annalsNavSideCreateVideoClicked
					: annalsNavTopCreateVideoClicked;
			case routes.generate.character:
				return sideMenu
					? annalsNavSideCreateCharacterClicked
					: annalsNavTopCreateCharacterClicked;

			case externalRoutes.becomeAffiliate:
				return sideMenu ? annalsNavSideAffiliateClicked : () => undefined;
			case externalRoutes.creatorUrl:
				return sideMenu ? annalsNavSidePartnershipClicked : () => undefined;
			default:
				return () => undefined;
		}
	};

	return { annalsNavigationClick };
};
